import { useState } from "react";
import { generateFile } from "services";

const useGenerateFile = (entity) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const doRequest = async () => {
    setIsLoading(true);

    const response = await generateFile(entity);

    setData(response);

    setIsLoading(false);
  };

  return { data, isLoading, doRequest };
};

export { useGenerateFile };
